<div class="row">
  <div class="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
    <div class="login-wrap">
      <h2>Unauthorised</h2>

      <p>You are not authorised to perform this action.</p>
    </div>
  </div>
</div>
